import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";

export default function JishiAllAgeAmblyopia({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: '突破弱视诊疗年龄瓶颈，集视医疗携脑科学驱动方案亮相全国小儿眼科年会',
      date: '2026-06',
      desc: '以“脑科学机制驱动・眼脑融合创新”为核心定位的集视医疗，在2026中华医学会斜视与小儿眼科学术大会上精彩亮相，向业界展示了旗下基于脑科学机制的弱视治疗解决方案——埃尔塔（ARTA），与全国眼科专家共探弱视诊疗前沿路径，引发行业广泛关注与认可。',
      img: '/images/news/pediatricConference8.jpg',
      route: '/newsInfo/pediatricConference'
    },
    {
      title: '温州医科大学附属眼视光医院＆集视医疗战略合作签约',
      date: '2024-10-31',
      desc: '2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室…',
      img: '/images/news/news1.png',
      route: '/newsInfo/contract'
    },
    {
      title: '集视医疗亮相中华医学会第二十八次眼科学术大会',
      date: '2024-09-04',
      desc: '2024年9月4-8日，中华医学会第二十八次眼科学术大会在武汉国际博览中心隆重举行，作为年度眼科行业最盛大的学术会议，全球逾万名专家、学者相聚于此，交流分享眼科和视觉科学方面最新研究成果…',
      img: '/images/news/academic3.png',
      route: '/newsInfo/academic'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div className="PreA">
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 出圈2026VC！｜集视医疗发布“全龄弱视诊疗黑科技”：基于脑科学机制，突破年龄限制</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className='article_title'>
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2026.06</span>
              </div>
              <div className="article_titleBottom">出圈2026VC！｜集视医疗发布“全龄弱视诊疗黑科技”：基于脑科学机制，突破年龄限制</div>
            </div>
            <div className='article_content'>
              <div className="article_content-text">
                津门聚智，睛启新篇！备受行业瞩目的2026视觉健康创新发展国际会议（Vision China 2026）近日在天津圆满落幕。<br /><br />
                作为脑科学视觉干预领域的探索者，集视医疗携其“全龄弱视诊疗”前沿技术与埃尔塔系列产品亮相大会，并正式加入人工智能眼镜科技创新与产业联盟，携手行业共建产业新生态。
              </div>
              <div className='article_content-text1'>
                01<br />
                双展位亮相，多维展现硬核创新实力
              </div>
              <div className='article_content-text'>
                弱视的传统治疗主要针对儿童，依赖于遮盖、压抑等疗法，但存在以下临床痛点：<br />
                • 年龄窗口限制：通常认为12岁以上患者疗效显著下降，成人弱视缺乏有效手段；<br />
                • 疗效波动与回退：部分患儿治疗后视力易回退；<br />
                • 拥挤现象难改善：弱视患者常见的“拥挤”症状（识别单个字母能力优于排列字母）缺乏针对性干预；<br />
                • 依从性挑战：遮盖疗法易引起患儿社交心理负担。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/jishiAllAgeAmblyopia1.png'
                  alt=''
                />
                <div className='img_tip'>图 | T17展位现场</div>
              </div>
              <div className='article_content-text'>
                集视医疗本次在T17核心展位重点展示了埃尔塔系列产品，提出基于脑神经调控机制的全龄干预路径，旨在从大脑视觉通路源头进行功能重塑，上述临床难题或可获得新的解决方案。此外，集视医疗还展出了智能视觉设备、视觉健康干预、数字化诊疗方案等领域的成熟产品与技术突破，展示了品牌深耕眼脑协同领域的技术沉淀与科研实力。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/jishiAllAgeAmblyopia2.png'
                  alt=''
                />
                <div className='img_tip'>图 | T30产品联展现场</div>
              </div>
              <div className='article_content-text'>
                T30展位聚焦全球智能眼镜前沿成果。本次展会中，集视携核心埃尔塔弱视诊疗产品重磅入驻该展位，与华为等行业头部品牌的全球智能眼镜产品同台展演，聚焦医疗前沿应用场景，全方位呈现智能眼镜在视觉健康干预、智慧护眼、临床辅助等领域的落地价值，吸引了大量行业专家、合作伙伴及观展者驻足观摩、深度交流，让大众直观感受顶尖科技跨界赋能眼健康的全新成果。
              </div>
              <div className='article_content-text1'>
                02<br />
                深耕行业，共建数字化视康新生态
              </div>
              <div className='article_content-text'>
                行业向上，聚力共生。本次大会期间，人工智能眼镜科技创新与产业联盟正式成立，集视凭借在智能视觉硬件、眼健康临床应用等领域的深厚积累与创新成果，受邀作为联盟核心成员单位出席成立仪式。<br /><br />
                作为联盟成员单位之一，集视将主动肩负行业责任，参与联盟各项工作，依托自身技术研发优势与临床实践经验，积极参与行业技术标准研讨、核心技术攻关、创新成果落地等工作。同时持续推动智能眼镜、数字化视觉干预技术的迭代升级，助力国内人工智能眼健康产业高质量、规范化发展。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/jishiAllAgeAmblyopia3.png'
                  alt=''
                />
                <div className='img_tip'>图 | 人工智能眼镜科技创新与产业联盟成立仪式</div>
              </div>
              <div className='article_content-text1'>
                03<br />
                专业赋能，传递行业新知
              </div>
              <div className='article_content-text'>
                以专业赋能行业，以科普链接大众。在展会期间的专场科普分享中，集视医疗特邀中科院生物物理所高弋戈博士阐释了埃尔塔产品的底层机制：“视觉康复不应仅局限于眼部训练，该产品以视觉通路调节为技术根基，通过特定视觉刺激方式，进行基于双眼分视下小细胞通路功能重建的推拉训练，全面提升视力和视功能，让全年龄段弱视的智能化、精准化诊疗成为可能。“
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/jishiAllAgeAmblyopia4.png'
                  alt=''
                />
                <div className='img_tip'>图 | 中科院生物物理所高弋戈博士</div>
              </div>
              <div className='article_content-text'>
                集视医学产品经理张旭昊结合美国弱视PPP指南与复旦附属眼耳鼻喉科医院、中科院的联合科研成果，详解了埃尔塔在病理性拥挤改善上的核心优势：“埃尔塔可提升患者小细胞通路感知与中央视野辨识能力，改善病理性拥挤，为弱视精准治疗提供了全新临床方案。”
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/jishiAllAgeAmblyopia5.png'
                  alt=''
                />
                <div className='img_tip'>图 | 集视医学产品经理张旭昊</div>
              </div>
              <div className='article_content-text'>
                两场专业分享兼具学术性、实用性与前瞻性，内容干货满满、互动氛围热烈，既展现了集视扎实的技术功底与专业积淀，也为行业同仁交流学习、资源对接搭建了优质平台。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/jishiAllAgeAmblyopia6.png'
                  alt=''
                />
                <img
                  style={{ width: '100%' }}
                  src='/images/news/jishiAllAgeAmblyopia7.png'
                  alt=''
                />
                <div className='img_tip'>图 | 展位互动</div>
              </div>
              <div className='article_content-text'>
                本次2026VC视觉健康大会的圆满落幕，是集视一次亮眼的行业亮相，更是品牌深耕创新、持续进阶的全新起点。从双展位创新展示、入局行业核心联盟，到大咖专业科普赋能，充分展现了集视医疗在脑科学与眼科治疗融合领域的硬核实力与行业担当。<br /><br />
                未来，集视将始终以「解码眼脑关联，创新视觉干预，守护每一段视觉发育旅程」为使命，深耕眼脑协同交叉学科领域，在深耕弱视精准诊疗、筑牢行业技术壁垒的基础上，持续将前沿眼脑理论与技术赋能斜视相关视功能训练、近视防控、青光眼缺损视野逆转等更多眼病诊疗赛道等更多眼病诊疗赛道。通过解码视觉信号与大脑认知的深层关联，
                突破传统干预手段在年龄、疗效、场景、患者依从性上的诸多局限，持续提升眼病临床干预效果与医疗可及性，以前沿科研力量守护大众视觉健康，让每个生命都能拥有与世界清晰对话的权利！
              </div>
              <div className='mt_60 img_tip'>免责声明：本文内容仅供行业学术交流、学术研讨及专业医疗领域参考使用，不构成任何商业广告、产品宣传及诊疗行为推荐。</div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/cellReportsAmblyopia'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/pediatricConference'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/cellReportsAmblyopia'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/pediatricConference'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
